import React from 'react'
import Header from './Header'
import Post from './Post'





const Home = () => {




  return (
    <div>
          <Header/>
          <Post/>
         
    </div>
  )
}

export default Home
